export const name = "DATE_ADD";
export const summary = `Adds a specified time interval to a \`DATE\` value.`;
export const reference = `
## DATE_ADD

Adds a specified time interval to a \`DATE\` value.

\`\`\`
DATE_ADD(date_expression, INTERVAL int64_expression date_part)
\`\`\`

### Description

Adds a specified time interval to a DATE.

\`DATE_ADD\` supports the following \`date_part\` values:

- \`DAY\`
- \`WEEK\`. Equivalent to 7 \`DAY\`s.
- \`MONTH\`
- \`QUARTER\`
- \`YEAR\`

Special handling is required for MONTH, QUARTER, and YEAR parts when the date is at (or near) the last day of the month. If the resulting month has fewer days than the original date's day, then the resulting date is the last date of that month.


### Return Data Type

DATE


### Example



\`\`\`
SELECT DATE_ADD(DATE '2008-12-25', INTERVAL 5 DAY) AS five_days_later;

/*--------------------*
 | five_days_later |
 +--------------------+
 | 2008-12-30 |
 *--------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/date_functions
`;
